/**
 * @file: useActiveTabIndex.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import type { TabNavParams } from '@euler/app/tv/pages/Home';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { BehaviorSubject } from 'rxjs';

export type HomeTab = keyof TabNavParams;

export const activeTab$ = new BehaviorSubject<HomeTab>('Dashboard');

export const useActiveTab = () => {
  const [activeTab] = useBehaviorSubject(activeTab$);
  return activeTab;
};
